import React from 'react';

const steps = [
  { key: 'draft', label: 'Rascunho' },
  { key: 'in_review', label: 'Revisão' },
  { key: 'in_approval', label: 'Aprovação' },
  { key: 'approved', label: 'Aprovado' },
];

const statusOrder = { draft: 0, in_review: 1, in_approval: 2, approved: 3, rejected: -1 };

export default function WorkflowPipeline({ currentStatus }) {
  const currentIdx = statusOrder[currentStatus] ?? -1;

  if (currentStatus === 'rejected') {
    return (
      <div className="flex items-center gap-2">
        <span className="status-stamp rejected">Rejeitado — retorna ao rascunho</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      {steps.map((step, i) => (
        <React.Fragment key={step.key}>
          {i > 0 && <span className="text-ink-faint text-xs">→</span>}
          <span className={`font-mono text-xs px-2.5 py-1 rounded border
            ${i === currentIdx
              ? 'border-brand text-brand bg-brand/[0.06] font-semibold'
              : i < currentIdx
                ? 'border-status-approved text-status-approved bg-status-approved/[0.06]'
                : 'border-DEFAULT text-ink-muted bg-surface-100'
            }`}>
            {step.label}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}
